angular.module('picmonicng').directive('scrollReachesTop', [
  function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var distanceOffset = 5;
        //There is an offSet bc the start of any scroll is at the top
        //Don't want to return a true away
        angular.element(element).bind('scroll', function () {
          scope.$apply(function () {
            scope.$parent.scrollIsAtTop = element.scrollTop() <= distanceOffset ? true : false;
          });
        });
      },
    };
  },
]);
